<template>
  <div>
    <DxSelectBox
      :search-enabled="true"
      :data-source="gridDataSource"
      :search-mode="searchModeOption"
      :search-expr="searchExprOption"
      :search-timeout="searchTimeoutOption"
      :min-search-length="minSearchLengthOption"
      :show-data-before-search="showDataBeforeSearchOption"
      :accept-custom-value="true"
      display-expr="name"
      :disabled="disabled"
      value-expr="id"
      :value="gridBoxValue"
      ref="rltfld"
      @value-changed="onValueChanged"
    />
  </div>
</template>

<script>
import { DxSelectBox } from "devextreme-vue/select-box";
import CustomStore from "devextreme/data/custom_store";

export default {
  props: {
    rRoute: String,
    slug: String,
    modelValue: String,
    disabled: Boolean,
    fieldName: String,
  },
  components: {
    DxSelectBox,
  },
  data() {
    return {
      gridDataSource: null,
      gridBoxValue: "",
      searchModeOption: "contains",
      searchExprOption: "name",
      searchTimeoutOption: 200,
      minSearchLengthOption: 0,
      showDataBeforeSearchOption: true,
      selectedItemName: "", // Track the selected item's name
    };
  },
  methods: {
    makeAsyncDataSource(rRoute, slug) {
      console.log("RELATE COMPONENT", rRoute, slug);

      return new CustomStore({
        key: "id",
        loadMode: "processed",
        load: function (loadOptions) {
          let listurl = "/" + slug + "/" + rRoute + "/rlt-fld-list";

          console.log("RELATE COMPONENT list url", listurl);

          var parameters = {};

          var tFilter = [
            loadOptions.searchExpr,
            loadOptions.searchOperation,
            loadOptions.searchValue,
          ];

          if (loadOptions.sort) {
            parameters.order_column = loadOptions.sort[0].selector;
            if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
          }
          if (
            loadOptions.searchExpr != null &&
            loadOptions.searchValue != null
          ) {
            parameters.filter = JSON.stringify(tFilter);
          }
          var config = {
            params: parameters,
          };

          return axios
            .get(listurl, config)
            .then((response) => {
              console.log(
                "RELATE COMPONENT Response",
                response.data.results.data
              );
              return {
                data: response.data.results.data,
                totalCount: response.data.results.total,
              };
            })
            .catch(() => {
              throw "Data Loading Error";
            });
        },
        byKey: function (key) {
          if (key !== null && key !== undefined && key !== "") {
            let url = "/" + slug + "/" + rRoute + "/getById/" + key;
            return axios
              .get(url)
              .then((response) => {
                return {
                  id: response.data.data.id,
                  name: response.data.data.name,
                };
              })
              .catch(() => {
                throw "Data Loading Error";
              });
          }
        },
      });
    },
    onValueChanged(e) {
      // Get the selected item with both ID and name
      const selectedItem = e.component.option("selectedItem");
      const selectedName = selectedItem ? selectedItem.name : "";

      // Store the selected name
      this.selectedItemName = selectedName;

      console.log("Selected Item: ", selectedItem);
      // Emit both the ID and the complete item
      this.$emit("update:modelValue", e.value);
      this.$emit("nameChanged", selectedName);
      this.$emit("itemSelected", {
        id: e.value,
        name: selectedName,
        fieldName: this.fieldName,
      });
    },
  },
  mounted() {
    console.log("dsd", this.modelValue);
    this.gridBoxValue = this.modelValue;
    console.log("Route and slug", this.rRoute, this.slug);

    this.gridDataSource = this.makeAsyncDataSource(this.rRoute, this.slug);

    // If we have an initial value, try to get its display name
    if (this.modelValue) {
      // You could potentially load the initial item's name here
      // This would make the component show the correct name immediately
      // instead of waiting for user interaction
    }
  },
};
</script>

<style></style>